import preparedReducer from './reducer';
import {
  requestBITasksByDate,
  requestBITasksByEmployee,
  requestBITasksBySite,
  requestBITasksBySiteAndDate,
  requestBITaskLog,
  requestBITasksScheduleStatistics,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biTasks';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBITasksBySiteAndDate,
  requestBITasksByDate,
  requestBITasksBySite,
  requestBITasksScheduleStatistics,
  requestBITasksByEmployee,
  requestBITaskLog,
};
